/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate an ideal body weight from your height and sex. Four classic clinical formulas are shown — they differ slightly, so treat the range as a guide rather than a single target.`)
};

const es_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima un peso corporal ideal a partir de tu altura y sexo. Se muestran cuatro fórmulas clínicas clásicas — difieren ligeramente, así que trata el rango como una guía y no como un único objetivo.`)
};

const de_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze ein Idealgewicht anhand deiner Körpergröße und deines Geschlechts. Vier klassische klinische Formeln werden angezeigt — sie unterscheiden sich leicht, betrachte die Spanne daher als Orientierung und nicht als exaktes Ziel.`)
};

const nl_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat een ideaal lichaamsgewicht op basis van je lengte en geslacht. Vier klassieke klinische formules worden getoond — ze verschillen licht van elkaar, dus zie de bandbreedte als richtlijn en niet als één vast doel.`)
};

const fr_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez un poids corporel idéal à partir de votre taille et de votre sexe. Quatre formules cliniques classiques sont affichées — elles diffèrent légèrement, considérez donc la fourchette comme un guide plutôt qu'un objectif unique.`)
};

const it_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima un peso corporeo ideale dalla tua altezza e dal tuo sesso. Vengono mostrate quattro formule cliniche classiche — differiscono leggermente, quindi considera l'intervallo come un'indicazione e non come un obiettivo unico.`)
};

const pt_br2_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime um peso corporal ideal a partir da sua altura e sexo. São exibidas quatro fórmulas clínicas clássicas — elas variam um pouco entre si, então trate a faixa como uma referência, não como um alvo único.`)
};

const pt_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime um peso corporal ideal a partir da sua altura e sexo. São apresentadas quatro fórmulas clínicas clássicas — diferem ligeiramente entre si, por isso trate o intervalo como uma referência e não como um objetivo único.`)
};

const ja_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長と性別から理想体重を推定します。4つの古典的な臨床計算式を表示します — それぞれわずかに異なるため、単一の目標値ではなく目安の範囲として捉えてください。`)
};

const zh_iw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据你的身高和性别估算理想体重。这里展示了四种经典的临床公式——它们的结果略有差异，因此请将其视为参考范围，而非单一目标值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_intro", locale)
	if (locale === "en") return en_iw_intro(inputs)
	if (locale === "es") return es_iw_intro(inputs)
	if (locale === "de") return de_iw_intro(inputs)
	if (locale === "nl") return nl_iw_intro(inputs)
	if (locale === "fr") return fr_iw_intro(inputs)
	if (locale === "it") return it_iw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_iw_intro(inputs)
	if (locale === "pt") return pt_iw_intro(inputs)
	if (locale === "ja") return ja_iw_intro(inputs)
	return zh_iw_intro(inputs)
};